import { render, staticRenderFns } from "./InProductBanner.vue?vue&type=template&id=7c7493c2&scoped=true"
import script from "./InProductBanner.vue?vue&type=script&lang=js"
export * from "./InProductBanner.vue?vue&type=script&lang=js"
import style0 from "./InProductBanner.vue?vue&type=style&index=0&id=7c7493c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7493c2",
  null
  
)

export default component.exports